import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sp-pagination',
  standalone: false,
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']

})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() query = {};
  @Input() dateQuery = {};
  @Input() basicQuery = {};
  @Input() DataService: DataServiceObjectInterface = {
    fetch: () => {}
  };

  @Input() pagination: PaginationObjectInterface = {
    currentPage: 1,
    next: 2,
    prev: 0,
    last: 20,
    pageSize: 20,
    totalItems: 200
  };
  paginateIcons = {
    dropdown: '/public/resources/images/icons/icon-forward.svg',
    next: '/public/resources/images/icons/pagination-arrow-next.svg',
    prev: '/public/resources/images/icons/pagination-arrow-prev.svg'
  };
  // pager object
  pager: any = {};

  // paged items
  pagedItems: any[];

  allPagesList: number[];

  constructor() {}

  ngOnInit() {

  }

  ngOnChanges() {

  }
  fetch(direction = null, pageSize = null) {
    if (pageSize) {
      this.pagination.pageSize = pageSize;
    }

    if (direction) {
      switch (direction) {
        case 'next':
          if (this.pagination.currentPage < this.pagination.last) {
            this.pagination.currentPage++;
          }
          break;
        case 'previous':
          if (this.pagination.currentPage > 0) {
            this.pagination.currentPage--;
          }
          if (this.pagination.currentPage === 0) {
            this.pagination.currentPage = 1;
          }
          break;
      }
    } else {
      this.pagination.currentPage = 1;
    }

    const query = { ...this.basicQuery };

    Object.keys(this.basicQuery).forEach(key => {
      switch (typeof this.basicQuery[key]) {
        case 'string':
          query[key] = this.basicQuery[key];
          break;
        case 'object':
          query[key] = this.basicQuery[key].id;
          break;
      }
    });

    this.DataService.fetch(query, this.pagination);
  }
}

export const updatePagination = (
  res,
  pagination,
  keys = {
    last: 'pagesCount',
    totalItems: 'totalCount'
  }
) => {
  pagination.last = res[keys.last];
  pagination.next = pagination.currentPage + 1;
  pagination.prev = pagination.currentPage - 1;
  pagination.totalItems = res[keys.totalItems];
  return pagination;
};

export interface PaginationObjectInterface {
  currentPage: number;
  pageSize: number;
  data?: Array<any>;
  totalItems?: number;
  next?: number;
  prev?: number;
  last?: number;
  fetch?: any;
}

interface DataServiceObjectInterface {
  fetch?: any;
}